module.exports = __webpack_public_path__ + "img/Pic_Text_ZTY.b32760de.png";